import gql from 'graphql-tag';
import RESOURCE_TYPE_FRAGMENT from './resource-type';
import RESOURCE_TYPE_ASSETS_FRAGMENT from './resource-type-assets';

const RESOURCE_FRAGMENT = gql`
  fragment BaseResource on Resource {
    id
    link
    grades
    title
    description
    productCodes
    link
    # type is eagerly loaded
    type {
      ...BaseResourceType
      ...BaseResourceTypeAssets
    }
    productFamily {
      id
      name
    }
  }
  ${RESOURCE_TYPE_FRAGMENT}
  ${RESOURCE_TYPE_ASSETS_FRAGMENT}
`;

export default RESOURCE_FRAGMENT;
